import * as React from "react";

function SvgLuckyOrange(props, ref) {
  return (
    <svg
      id="luckyOrange_svg__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 102.2 142"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".luckyOrange_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#6cb144}"
        }
      </style>
      <g id="luckyOrange_svg__Page-1_1_">
        <g id="luckyOrange_svg__ColorWhite_x2F_Wordmark">
          <g id="luckyOrange_svg__Wordmark">
            <g id="luckyOrange_svg__Left">
              <g id="luckyOrange_svg__Page-1" transform="translate(444.581)">
                <g id="luckyOrange_svg__orage-large-clover">
                  <linearGradient
                    id="luckyOrange_svg__Shape_6_"
                    gradientUnits="userSpaceOnUse"
                    x1={-1331.365}
                    y1={620.699}
                    x2={-1331.365}
                    y2={619.81}
                    gradientTransform="matrix(95.5311 0 0 -94.4497 126789.984 58680.965)"
                  >
                    <stop offset={0} stopColor="#ffda58" />
                    <stop offset={0.129} stopColor="#fcc347" />
                    <stop offset={0.295} stopColor="#f9a936" />
                    <stop offset={0.464} stopColor="#f7962b" />
                    <stop offset={0.636} stopColor="#f68924" />
                    <stop offset={0.812} stopColor="#f58121" />
                    <stop offset={1} stopColor="#f57e20" />
                  </linearGradient>
                  <path
                    id="luckyOrange_svg__Shape"
                    d="M-386.6 47.6c-3.1.4-6.5.7-10 .7-3.6 0-7.1-.3-10.2-.8-21.6 4.6-37.8 23.8-37.8 46.7 0 26.4 21.4 47.8 47.8 47.8s47.8-21.4 47.8-47.8c0-22.8-16.1-41.9-37.6-46.6zm6.5 51.4l-22.2 12.8c-3.1 1.8-6.9-.4-6.9-3.9V82.3c0-3.5 3.8-5.7 6.9-3.9l22.2 12.8c3.1 1.6 3.1 6 0 7.8z"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="url(#luckyOrange_svg__Shape_6_)"
                  />
                  <g
                    id="luckyOrange_svg__noun_224115_cc-copy"
                    transform="rotate(51 40.926 87.497)"
                  >
                    <g id="luckyOrange_svg__Group">
                      <path
                        id="luckyOrange_svg__Shape_1_"
                        className="luckyOrange_svg__st1"
                        d="M-286.4 372.1c1.7 3.8 5.4 6.7 6.9 7.3 1.6.6 3.2.6 4.8-.1s2.7-1.9 3.2-3.4l6.3-13.4-14.2-4.3c-3.2-1.3-6.8.3-8.1 3.5-.5 1.7-.7 6.5 1.1 10.4z"
                      />
                      <path
                        id="luckyOrange_svg__Shape_2_"
                        className="luckyOrange_svg__st1"
                        d="M-256.9 384.2c4.1-1.8 8.5-5.7 9.1-7.4 1.3-3.2-.4-6.8-3.6-8.1l-13.5-6.2-4.3 14.2c-.6 1.6-.6 3.2.1 4.8.7 1.5 1.9 2.7 3.4 3.2s5.1 1 8.8-.5z"
                      />
                      <path
                        id="luckyOrange_svg__Shape_3_"
                        className="luckyOrange_svg__st1"
                        d="M-252.6 344.7c-2.5 0-4.9 1.5-5.8 4l-6.3 13.4 14.2 4.3c3.2 1.3 6.8-.4 8.1-3.6.6-1.6.8-6.4-1-10.2-1.7-3.8-5.4-6.8-7-7.4-.7-.3-1.4-.5-2.2-.5z"
                      />
                      <path
                        id="luckyOrange_svg__Shape_4_"
                        className="luckyOrange_svg__st1"
                        d="M-266.6 339.4c-1.1 0-5.2.2-8.3 1.7-3.8 1.8-6.5 5-7.2 6.7-1.3 3.2.4 6.8 3.6 8.1l13.5 6.2 4.2-14.2c.6-1.6.6-3.2-.1-4.8-.6-1.5-1.8-2.6-3.4-3.2-.8-.3-1.6-.5-2.3-.5z"
                      />
                      <path
                        id="luckyOrange_svg__Shape_5_"
                        className="luckyOrange_svg__st1"
                        d="M-271.9 380.4c-.6.4-1.1.8-1.8 1.1-.1.1-.1.1-.3.1-1.3 3.9-3.2 15.5 3.6 22.6 0 0 2.4-1.8 3.2-2.9s2.4-4 2.4-4c-5.8-4.6-7.3-10.6-6.5-14.8.1.1-.5-1.4-.6-2.1z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgLuckyOrange);
